import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function TrustBadge() {
  return <div className="flex items-center justify-center mt-3" data-id="element-461">
      <ShieldCheckIcon className="h-5 w-5 text-gray-600 mr-2" data-id="element-462" />
      <p className="text-sm text-gray-700" data-id="element-463">
        No subscription. Lifetime access. Try risk-free for 30 days.
      </p>
    </div>;
}